import { render } from "./PbxHeader.vue?vue&type=template&id=46c2f4e4&scoped=true"
import script from "./PbxHeader.vue?vue&type=script&lang=js"
export * from "./PbxHeader.vue?vue&type=script&lang=js"

import "./PbxHeader.vue?vue&type=style&index=0&id=46c2f4e4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46c2f4e4"

export default script